import { Box, Flex, Text, Tooltip, useColorModeValue } from '@chakra-ui/react';

const STATUS_STYLES = {
  active: { bg: 'rgba(153, 204, 51, 0.5)', color: '#339900', label: 'Active' },
  issued: { bg: 'rgba(75, 110, 245, 0.5)', color: '#4b6ef5', label: 'Issued' },
  removed: {
    bg: 'rgba(201, 201, 201, 0.5)',
    color: '#6c6c6c',
    label: 'Removed',
  },
  deactivated: {
    bg: 'rgba(255, 86, 83, 0.5)',
    color: '#e30000',
    label: 'Deactivated',
  },
  expired: { bg: 'rgba(252, 134, 0, 0.5)', color: '#d56700', label: 'Expired' },
  pending: {
    bg: 'rgba(75, 110, 245, 0.5)',
    color: '#4b6ef5',
    label: 'Pending',
  },
};

const PassesRenderStatus = ({ value, hasTooltip, light = false }) => {
  const bgTooltip = useColorModeValue('secondaryDark', '#dddddd');
  const textTooltip = useColorModeValue('#ffffff', 'primaryDark');
  const tooltipWidth = value === 'active' ? '197px' : '170px';

  const tooltipMessage = {
    issued: 'Pass is ready to be added to a wallet.',
    active: 'Pass has been added to a wallet.',
    expired:
      'Pass can not be added to a wallet or scanned as the event has passed.',
    pending: 'Pass has been sent, but not added to a wallet yet.',
    removed: 'Pass has been removed from a wallet.',
    deactivated:
      'Pass can not be added to a wallet or scanned as it was deactivated by issuer.',
  };

  const style = STATUS_STYLES[value];

  if (!style) {
    return <Box color="error">n/a</Box>;
  }

  const badge = (
    <Flex
      bg={style.bg}
      borderRadius="20px"
      py="5px"
      px="10px"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
    >
      <Text
        textStyle={light ? 'bodyFamilyRegular' : 'bodyFamilyMedium'}
        fontSize="12px"
        color={style.color}
        lineHeight="1.3"
        whiteSpace="nowrap"
      >
        {style.label}
      </Text>
    </Flex>
  );

  if (hasTooltip && tooltipMessage[value]) {
    return (
      <Tooltip
        label={tooltipMessage[value]}
        hasArrow
        placement="top"
        fontSize="12px"
        color={textTooltip}
        w={tooltipWidth}
        borderRadius="6px"
        bg={bgTooltip}
        textAlign="center"
        p="10px"
        mb="5px"
        closeOnClick={false}
      >
        {badge}
      </Tooltip>
    );
  }

  return badge;
};

export default PassesRenderStatus;
